import React, { PureComponent } from 'react'
import { Form, Input, Modal,Select, message} from 'antd'
import moment from 'moment';
import 'moment/locale/zh-cn';
import {baseUrl, reqCountryList} from '../../api'
moment.locale('zh-cn');
const {Option} = Select;
const formItemLayout = {
    labelCol: {
        span: 6,
    },
    wrapperCol: {
        span: 14,
    },
}
const title={
    add:'新增城市',
    update:'修改城市'
}
class CityModal extends PureComponent {
    state = {
        city: {},
        countryList: []
    }

    getCountries = async () => {
        let result = await reqCountryList({})
        if (result.code === 200) {
            this.setState({
                countryList: result.data
            })
        } else {
            message.error(result.message)
        }

    }

    handleOk = () => {
        const {onCityOk} = this.props
        const { validateFields, getFieldsValue, resetFields } = this.props.form
        validateFields((errors,values) => {
            if (errors) {
                return
            }
            const data = {
                ...getFieldsValue(),
            }
            resetFields()
            data.id = this.state.city.id
            onCityOk(data)
        })
    }

    hideModal = () =>{
        const {onCityCancel} = this.props
        const {resetFields } = this.props.form
        onCityCancel()
        resetFields()
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.city) {
            this.setState({
                city: nextProps.city
            },()=>{
                this.getCountries()
            })
        }
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const {action, visible} = this.props
        return (
            <Modal  onOk={this.handleOk}
                    title={title[action]}
                    visible={visible}
                    onCancel={this.hideModal}
                    okText="确定"
                    cancelText="取消"
            >
                <Form {...formItemLayout}>
                    <Form.Item label="所在国家:">
                        {getFieldDecorator('countryId', {
                            initialValue: this.state.city.countryId,
                            rules: [{required: true, message: '该项必填'}]
                        })(<Select getPopupContainer={triggerNode => triggerNode.parentNode}>
                            {this.state.countryList.map(country => (
                                <Option key={country.id} value={country.id}>{country.name}</Option>
                            ))}
                        </Select>)}
                    </Form.Item>
                    <Form.Item label="城市(中文):">
                        {getFieldDecorator('name', {
                            initialValue: this.state.city.name,
                            rules: [{required: true, message: '该项必填'}]
                        })(<Input />)}
                    </Form.Item>
                    <Form.Item label="城市(英文):">
                        {getFieldDecorator('nameEn', {
                            initialValue: this.state.city.nameEn,
                            rules: [{required: true, message: '该项必填'}]
                        })(<Input />)}
                    </Form.Item>
                    <Form.Item label="类型:">
                        {getFieldDecorator('type', {
                            initialValue: (this.state.city.type? this.state.city.type:'F'),
                            rules: [{required: true, message: '该项必填'}]
                        })(<Select getPopupContainer={triggerNode => triggerNode.parentNode}>
                            <Option value="F">出发地</Option>
                            <Option value="D">转关地</Option>
                            <Option value="T">目的地</Option>
                            <Option value="C">清关地</Option>
                        </Select>)}
                    </Form.Item>
                </Form>
            </Modal>
        )
    }
}
const WrapCityModal= Form.create()(CityModal)
export default WrapCityModal
